import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Card, Heading, Text } from '@aws-amplify/ui-react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
    };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Card variation="elevated" padding="medium">
          <Heading level={3}>Sorry.. there was an error</Heading>
          <Text>{this.state.error?.message}</Text>
        </Card>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
